export default {
  selectedUserRoleState: state => state.selectedUserRole
}
